import type { ChecklistItem } from '@/types/material'

const GROUPS: { key: keyof Record<'block' | 'suggest' | 'tip', ChecklistItem[]>; title: string; hint: string; box: string; dot: string }[] = [
  { key: 'block', title: '阻断项', hint: '不补齐/不拍板不能下单', box: 'border-danger/25 bg-danger-soft', dot: 'bg-danger' },
  { key: 'suggest', title: '建议核对', hint: '可以询价，但需人工确认', box: 'border-warn/25 bg-warn-soft', dot: 'bg-warn' },
  { key: 'tip', title: '提示', hint: '品类陷阱与写法提醒', box: 'border-line bg-surface-2', dot: 'bg-muted' },
]

export function Checklist({ checklist }: { checklist: Record<'block' | 'suggest' | 'tip', ChecklistItem[]> }) {
  const groups = GROUPS.map((g) => ({ ...g, items: checklist[g.key] })).filter((g) => g.items.length > 0)

  if (groups.length === 0) {
    return <p className="px-3 py-4 text-xs text-muted">无待办项</p>
  }

  return (
    <div className="flex flex-col gap-3 p-3">
      {groups.map((group) => (
        <section key={group.key} className={`rounded-control border px-3 py-2.5 ${group.box}`}>
          <header className="flex items-baseline gap-2">
            <h3 className="text-[13px] font-semibold text-ink">
              {group.title} <span className="text-muted">{group.items.length}</span>
            </h3>
            <p className="text-[11px] text-muted">{group.hint}</p>
          </header>
          <ul className="mt-2 flex flex-col gap-2">
            {group.items.map((item, i) => (
              <li key={`${item.field ?? 'general'}-${i}`} className="flex gap-2 text-[12px] leading-relaxed">
                <span className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full ${group.dot}`} />
                <div className="min-w-0">
                  <p className="font-medium text-ink">{item.message}</p>
                  {item.action && <p className="text-muted">{item.action}</p>}
                </div>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  )
}
